export default __webpack_public_path__ + "svg/powered/adigital.svg?f08d32aa";